<script>
export default {
  name: 'CpDropdownMenu',
  components: {
    CpButton: require('../button').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginLeft: require('../directives/margins').marginLeft,
    marginRight: require('../directives/margins').marginRight,
  },
  props: {
    clickToggle: {
      type: Boolean,
      default: false,
    },
    campaignHqLink: { type: String, default: '' },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    handleToggle() {
      if (this.clickToggle) {
        this.isOpen = !this.isOpen;
      }
    },
    handleMouseEnter() {
      if (!this.clickToggle) {
        this.isOpen = true;
      }
    },
    handleMouseLeave() {
      if (!this.clickToggle) {
        this.isOpen = false;
      }
    },
  },
};
</script>
<template>
  <div class="dropdown" :class="{ 'click-toggle': clickToggle }" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <a class="dropbtn" @click="handleToggle">
      <i class="fal fa-question-circle fa-1-5x"></i>
      <span v-if="!$root.isMobile" class="buttons" v-margin-left="0.5">About CrowdBlue</span>
    </a>

    <!-- Dropdown content for hover mode -->
    <div v-if="!clickToggle" class="dropdown-content" :class="{ show: isOpen }">
      <a href="/about">About Us</a>
      <a href="mailto:support@crowdblue.com">Support</a>
      <a href="/campaigns/learn">How Campaigns Work</a>
      <a href="/about/privacy">Privacy Policy</a>
      <a href="/about/terms">Terms of Use</a>
      <a href="/community-guidelines">Community Guidelines</a>
      <a :href="campaignHqLink" target="_blank" rel="noopener noreferrer">CrowdBlue Campaign HQ</a>
      <a href="/pages/were-a-proud-member-of-connectblue">Advertise with Us</a>
    </div>

    <!-- Inline content for click toggle mode - styled like sidebar menu -->
    <div v-if="clickToggle" v-show="isOpen" class="more-options-container">
      <a href="/about">About Us</a>
      <a href="mailto:support@crowdblue.com">Support</a>
      <a href="/campaigns/learn">How Campaigns Work</a>
      <a href="/about/privacy">Privacy Policy</a>
      <a href="/about/terms">Terms of Use</a>
      <a href="/community-guidelines">Community Guidelines</a>
      <a :href="campaignHqLink" target="_blank" rel="noopener noreferrer">CrowdBlue Campaign HQ</a>
      <a href="/pages/were-a-proud-member-of-connectblue">Advertise with Us</a>
    </div>
  </div>
</template>

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown,
.dropdown:hover {
  cursor: pointer;
}

.dropbtn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: var(--white);
  width: max-content;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  left: 100%;
  bottom: 0px;
}

.dropdown-content.show {
  display: block;
}

.dropdown-content a {
  color: black;
  padding: 12px;
  text-decoration: none;
  display: block;
  border-bottom: 1px solid var(--neutral3);
}

.dropdown-content a:last-child {
  border-bottom: none;
}

.dropdown-content a:hover {
  background-color: var(--neutral1);
}

.more-options-container {
  display: flex;
  padding-left: 30px;
  padding-top: 12px;
  flex-direction: column;
  gap: 12px;
}

.more-options-container a {
  color: var(--black);
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
}

.more-options-container a:hover {
  color: var(--primary);
  background-color: var(--primary-blue-100);
}

.dropdown:not(.click-toggle):hover .dropdown-content {
  display: block;
}

.dropdown:not(.click-toggle):hover .dropbtn {
  color: var(--primary);
  background-color: var(--primary-blue-200);
  border-radius: 4px;
}

/* Click behavior */
.dropdown.click-toggle .dropbtn {
  transition: all 0.3s;
}

.dropdown.click-toggle .dropbtn:hover,
.dropdown.click-toggle .dropbtn.active {
  color: var(--primary);
  background-color: var(--primary-blue-200);
  border-radius: 4px;
}

@media screen and (max-width: 1025px) {
  .dropbtn {
    padding-left: 10px;
  }
}

@media screen and (max-width: 768px) {
  .dropbtn {
    padding-left: 0;
  }
}
</style>
